import React, { useEffect } from 'react';
import type { RouteComponentProps } from 'react-router';
import { Redirect } from 'react-router';
import { useLocation } from 'react-router-dom';
import { qs } from 'url-parse';

import type { StaticContext } from '@swf/core/types/StaticContext';
import { tryParse } from '@swf/core/utils/api';
import { launchGame } from '@swf/core/utils/casino';

export interface CasinoLaunchPayload {
  code: string;
  raceId: string;
  fsb: string;
}

const CasinoGameLaunch: React.FC<
  RouteComponentProps<{ id: string; type: 'game' | 'race' }, StaticContext>
> = ({ match, staticContext = {} }) => {
  const location = useLocation();
  const id = match.params.type === 'race' ? match.params.id : tryParse(match.params.id);

  useEffect(() => {
    const { code, raceId, fsb } = qs.parse(location.search) as CasinoLaunchPayload;
    const race = match.params.type === 'race';
    launchGame({ id, code, raceId, race, fsb, externalLaunch: true });
  }, [id, location.search, match.params.type]);

  staticContext.prefetch = ({ dispatch }, options) => dispatch.page.fetchPage(options);
  return <Redirect to="/" />;
};

export default CasinoGameLaunch;
